import { Link } from 'react-router-dom';
import { blogArticles } from '@/mocks/blog';

export default function BlogPreview() {
  const allArticles = blogArticles;

  return (
    <section className="py-24 md:py-32 px-6 md:px-10 bg-background-100">
      <div className="max-w-[1280px] mx-auto">
        <div className="text-center mb-16">
          <div className="flex items-center justify-center gap-2 mb-4">
            <span className="w-3 h-3 rounded-full bg-accent-500"></span>
            <span className="text-[11px] font-semibold text-accent-700 uppercase tracking-wider">Latest Guides</span>
          </div>
          <h2 className="text-[32px] md:text-[40px] font-heading text-foreground-950">
            itaobuy sheet <span className="italic text-foreground-600">Resources</span>
          </h2>
          <p className="text-[13px] text-foreground-500 mt-3">
            Expert guides, comparisons, and tips to master the itaobuy spreadsheet system
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {/* Featured hero card — article 0 */}
          <Link
            to={`/${allArticles[0].slug}`}
            className="md:col-span-2 group rounded-2xl overflow-hidden relative h-[320px] cursor-pointer"
          >
            <img
              src="https://readdy.ai/api/search-image?query=Elegant%20minimalist%20workspace%20with%20laptop%20displaying%20organized%20spreadsheet%20and%20product%20catalog%20on%20screen%2C%20warm%20natural%20side%20lighting%2C%20clean%20modern%20desk%20setup%2C%20editorial%20photography%2C%20cream%20beige%20tones%2C%20professional%20aesthetic%20composition&width=1200&height=640&seq=blog-hero-featured-v3&orientation=landscape"
              alt={allArticles[0].title}
              className="absolute inset-0 w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/30 to-transparent"></div>
            <div className="absolute bottom-0 left-0 right-0 p-8">
              <div className="flex items-center gap-3 mb-3">
                <span className="text-[10px] font-semibold text-background-50/80 uppercase tracking-wider bg-white/20 px-2.5 py-1 rounded-full">
                  {allArticles[0].category}
                </span>
                <span className="text-[11px] text-white/60">{allArticles[0].date}</span>
              </div>
              <h3 className="text-[18px] md:text-[22px] font-heading text-white font-semibold leading-snug mb-2 group-hover:underline">
                {allArticles[0].title}
              </h3>
              <p className="text-[12px] text-white/70 leading-relaxed max-w-[500px]">
                {allArticles[0].summary}
              </p>
            </div>
          </Link>

          {/* Quote style card — article 1 */}
          <Link
            to={`/${allArticles[1].slug}`}
            className="group rounded-2xl overflow-hidden bg-background-50 p-6 flex flex-col justify-between cursor-pointer hover:bg-background-100 transition-colors"
          >
            <div>
              <div className="flex items-center gap-3 mb-4">
                <span className="text-[10px] font-semibold text-accent-700 uppercase tracking-wider bg-accent-100 px-2.5 py-1 rounded-full">
                  {allArticles[1].category}
                </span>
                <span className="text-[10px] text-foreground-500">{allArticles[1].date}</span>
              </div>
              <div className="text-[40px] text-accent-400 mb-4 leading-none">
                <i className="ri-double-quotes-l"></i>
              </div>
              <h3 className="text-[14px] font-semibold text-foreground-950 leading-snug mb-3 group-hover:underline">
                {allArticles[1].title}
              </h3>
              <p className="text-[12px] text-foreground-600 leading-relaxed line-clamp-2">
                {allArticles[1].summary}
              </p>
            </div>
            <div className="mt-4 flex items-center gap-2 text-[12px] text-foreground-500">
              <i className="ri-time-line"></i>
              <span>{allArticles[1].readTime}</span>
            </div>
          </Link>

          {/* Wide comparison card — article 2 */}
          <Link
            to={`/${allArticles[2].slug}`}
            className="md:col-span-2 group rounded-2xl overflow-hidden relative h-[260px] cursor-pointer"
          >
            <img
              src="https://readdy.ai/api/search-image?query=Clean%20split%20screen%20comparison%20concept%20showing%20organized%20versus%20cluttered%20workspace%2C%20minimalist%20aesthetic%2C%20soft%20natural%20lighting%2C%20editorial%20style%2C%20professional%20composition%2C%20neutral%20tones&width=1200&height=520&seq=blog-wide-compare-v3&orientation=landscape"
              alt={allArticles[2].title}
              className="absolute inset-0 w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-black/70 to-black/20"></div>
            <div className="absolute bottom-0 left-0 right-0 p-8">
              <div className="flex items-center gap-3 mb-3">
                <span className="text-[10px] font-semibold text-background-50/80 uppercase tracking-wider bg-white/20 px-2.5 py-1 rounded-full">
                  {allArticles[2].category}
                </span>
                <span className="text-[11px] text-white/60">{allArticles[2].date}</span>
              </div>
              <h3 className="text-[18px] font-heading text-white font-semibold leading-snug mb-2 max-w-[450px] group-hover:underline">
                {allArticles[2].title}
              </h3>
              <p className="text-[12px] text-white/70 leading-relaxed max-w-[400px]">
                {allArticles[2].summary}
              </p>
            </div>
          </Link>

          {/* Small side card — article 3 */}
          <Link
            to={`/${allArticles[3].slug}`}
            className="group rounded-2xl overflow-hidden bg-background-50 cursor-pointer hover:bg-background-100 transition-colors flex flex-col"
          >
            <div className="h-[140px] overflow-hidden">
              <img
                src={allArticles[3].thumb}
                alt={allArticles[3].title}
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
              />
            </div>
            <div className="p-5 flex flex-col flex-1">
              <div className="flex items-center gap-3 mb-3">
                <span className="text-[10px] font-semibold text-secondary-700 uppercase tracking-wider bg-secondary-100 px-2.5 py-1 rounded-full">
                  {allArticles[3].category}
                </span>
                <span className="text-[10px] text-foreground-500">{allArticles[3].date}</span>
              </div>
              <h3 className="text-[14px] font-semibold text-foreground-950 leading-snug mb-2 group-hover:underline line-clamp-2">
                {allArticles[3].title}
              </h3>
              <p className="text-[12px] text-foreground-600 leading-relaxed line-clamp-2 mb-3">
                {allArticles[3].summary}
              </p>
              <div className="flex items-center gap-2 mt-auto text-[11px] text-foreground-500">
                <i className="ri-time-line"></i>
                <span>{allArticles[3].readTime}</span>
              </div>
            </div>
          </Link>

          {/* Row of 4 cards — articles 4-7 */}
          <div className="md:col-span-3 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 mt-2">
            {allArticles.slice(4, 8).map((art) => (
              <Link
                key={art.id}
                to={`/${art.slug}`}
                className="group rounded-2xl overflow-hidden bg-background-50 cursor-pointer hover:bg-background-100 transition-colors flex flex-col"
              >
                <div className="h-[160px] overflow-hidden">
                  <img
                    src={art.thumb}
                    alt={art.title}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
                  />
                </div>
                <div className="p-5 flex flex-col flex-1">
                  <div className="flex items-center gap-2.5 mb-3">
                    <span className="text-[10px] font-semibold text-secondary-700 uppercase tracking-wider bg-secondary-100 px-2 py-0.5 rounded-full">
                      {art.category}
                    </span>
                    <span className="text-[9px] text-foreground-500">{art.date}</span>
                  </div>
                  <h3 className="text-[13px] font-semibold text-foreground-950 leading-snug mb-2 group-hover:underline line-clamp-2">
                    {art.title}
                  </h3>
                  <p className="text-[11px] text-foreground-600 leading-relaxed mb-3 line-clamp-2">
                    {art.summary}
                  </p>
                  <div className="flex items-center gap-2 mt-auto text-[11px] text-foreground-500">
                    <i className="ri-time-line"></i>
                    <span>{art.readTime}</span>
                  </div>
                </div>
              </Link>
            ))}
          </div>

          {/* Row of 4 cards — articles 8-11 */}
          <div className="md:col-span-3 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
            {allArticles.slice(8, 12).map((art) => (
              <Link
                key={art.id}
                to={`/${art.slug}`}
                className="group rounded-2xl overflow-hidden bg-background-50 cursor-pointer hover:bg-background-100 transition-colors flex flex-col"
              >
                <div className="h-[160px] overflow-hidden">
                  <img
                    src={art.thumb}
                    alt={art.title}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
                  />
                </div>
                <div className="p-5 flex flex-col flex-1">
                  <div className="flex items-center gap-2.5 mb-3">
                    <span className="text-[10px] font-semibold text-secondary-700 uppercase tracking-wider bg-secondary-100 px-2 py-0.5 rounded-full">
                      {art.category}
                    </span>
                    <span className="text-[9px] text-foreground-500">{art.date}</span>
                  </div>
                  <h3 className="text-[13px] font-semibold text-foreground-950 leading-snug mb-2 group-hover:underline line-clamp-2">
                    {art.title}
                  </h3>
                  <p className="text-[11px] text-foreground-600 leading-relaxed mb-3 line-clamp-2">
                    {art.summary}
                  </p>
                  <div className="flex items-center gap-2 mt-auto text-[11px] text-foreground-500">
                    <i className="ri-time-line"></i>
                    <span>{art.readTime}</span>
                  </div>
                </div>
              </Link>
            ))}
          </div>

          {/* Row of 2 cards — articles 12-13 */}
          <div className="md:col-span-3 grid grid-cols-1 sm:grid-cols-2 gap-5 max-w-[66%] mx-auto">
            {allArticles.slice(12, 14).map((art) => (
              <Link
                key={art.id}
                to={`/${art.slug}`}
                className="group rounded-2xl overflow-hidden bg-background-50 cursor-pointer hover:bg-background-100 transition-colors flex flex-col"
              >
                <div className="h-[160px] overflow-hidden">
                  <img
                    src={art.thumb}
                    alt={art.title}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
                  />
                </div>
                <div className="p-5 flex flex-col flex-1">
                  <div className="flex items-center gap-2.5 mb-3">
                    <span className="text-[10px] font-semibold text-secondary-700 uppercase tracking-wider bg-secondary-100 px-2 py-0.5 rounded-full">
                      {art.category}
                    </span>
                    <span className="text-[9px] text-foreground-500">{art.date}</span>
                  </div>
                  <h3 className="text-[13px] font-semibold text-foreground-950 leading-snug mb-2 group-hover:underline line-clamp-2">
                    {art.title}
                  </h3>
                  <p className="text-[11px] text-foreground-600 leading-relaxed mb-3 line-clamp-2">
                    {art.summary}
                  </p>
                  <div className="flex items-center gap-2 mt-auto text-[11px] text-foreground-500">
                    <i className="ri-time-line"></i>
                    <span>{art.readTime}</span>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}